import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const ActivityIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <g id="Symbols">
          <g id="Icon-_x2F_-Events" transform="translate(-2.000000, -5.000000)">
            <path
              id="icon_x2F_toggle_x2F_check_x5F_box_x5F_outline_x5F_blank_x5F_24px"
              d="M19,18c0.6,0,1,0.4,1,1s-0.4,1-1,1
			h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1H19z M19,14c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1H9c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1H19z M22,12v10H6
			V12H22L22,12z M21.8,10H6.2C5,10,4,10.7,4,11.6v10.9C4,23.3,5,24,6.2,24h15.6c1.2,0,2.2-0.7,2.2-1.6V11.6C24,10.7,23,10,21.8,10z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default ActivityIcon;
